<template>
  <v-row>
    <v-col cols="12" sm="4" class="pb0-xs">
      <div class="d-block text-subtitle-2 font-weight-bold black--text">
        File
        <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
      </div>
    </v-col>
    <v-col cols="12" sm="8" class="pb0-xs">
      <v-badge color="green" :value="listData.length" :content="listData.length">
        <v-btn color="primary" dark @click.stop="dialog = true">
          Upload File
        </v-btn>
      </v-badge>

    </v-col>
    <v-dialog 
      scrollable presistent v-model="dialog" max-width="1024">
      <v-card>
        <v-card-title class="text-h5">
          Upload File
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" class="pb0-xs">
              <v-file-input label="Pilih file" :accept="accepted" ref="upload" :multiple="type == 'image'"
                v-model="selectedFiles" @change="checkImage" v-show="!disabled"></v-file-input>
              <v-btn @click="uploadFiles" v-show="!disabled" color="primary">Upload</v-btn>
            </v-col>
            <v-col>
              <template >
                Progress Upload
                <v-row>
                  <v-col>
                    <progress style="width:100%" id="file" :value="uploadProgress" :max="selectedFiles.length"> {{
                        uploadProgress }} of {{ selectedFiles.length }}</progress>
                  </v-col>
                </v-row>
              </template>
              <v-row>
                Uploaded {{ listData.length }} File
              </v-row>
              <v-row>
                <v-col v-viewer="{
        movable: false,
        toolbar: false,
        fullscreen: true,
        title: false,
      }" v-for="(file, index) in listData" :key="index" cols="12" md="3">
                  <v-card class="card-upload images">
                    <v-btn @click="remove(index)" title="Hapus" class="delete-upload" fab small v-show="!disabled"
                      color="red"><v-icon color="white">mdi-close</v-icon></v-btn>
                    <img class="img-fluid" v-if="type !== 'pdf'" :src="file" />
                    <v-card-text v-else>
                      PDF: <a :href="file" target="_blank">Preview</a>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.stop="dialog = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    type: String,
    orientation: String,
    listData: Array,
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    accepted() {
      if (this.type == "pdf") return "application/pdf";
      return "image/jpg, image/jpeg, image/png";
    },
    currentProgressBar() {
      return this.uploadProgress / 100
    },
    allProgressBar() {
      return this.selectedFiles / 100
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      uploadProgress: 10, // Kemajuan unggahan file
      selectedFiles: [],
      uploadedFiles: [],
      maxFiles: 50, // Jumlah maksimum file yang dapat diunggah
      filesPerRequest: 10, // Jumlah file per permintaan
    };
  },
  methods: {
    ...mapActions("productSeller", ["uploadImageV2"]),
    remove(idx) {
      this.listData.splice(idx, 1);
    },
    checkImage(val) {
      if (this.type == "pdf") return;
      // Pastikan jumlah file tidak melebihi batas maksimum
      if (val.length > this.maxFiles) {
        alert(`Anda hanya dapat mengunggah maksimal ${this.maxFiles} file.`);
        this.selectedFiles = [];
        return;
      }
      val.forEach((file) => {
        console.log("load");
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            // Periksa apakah gambar berorientasi potret atau lanskap
            let isPortrait = image.height > image.width;
            let isLandscape = image.width > image.height;
            if (this.orientation == "landscape") {
              if (!isLandscape) {
                alert("Gambar Portrait tidak diizinkan.");
                this.selectedFiles = [];
                return;
              }
            } else {
              if (!isPortrait) {
                alert("Gambar Landscape tidak diizinkan.");
                this.selectedFiles = [];
                return;
              }
            }
          };
        };
        reader.readAsDataURL(file);
      });
    },
    // async uploadFiles() {
    //   this.loading = true;
    //   setTimeout(() => {
    //     if (this.selectedFiles.length === 0) {
    //       alert("Pilih beberapa file terlebih dahulu.");
    //       this.loading = false;
    //       return;
    //     }
    //     try {
    //       this.selectedFiles.forEach(async (i) => {
    //         const formData = new FormData();
    //         formData.append("attachment", i);
    //         // Ganti 'YOUR_API_ENDPOINT' dengan URL API Anda
    //         await this.uploadImageV2(formData)
    //           .then((res) => {
    //             // Simpan URL file yang dikembalikan oleh API ke dalam data array
    //             this.listData.push(res.product_path);
    //             this.loading = false;
    //           })
    //           .catch((error) => {
    //             this.loading = false;

    //             console.error("Error:", error);
    //           });
    //       })
    //     } catch (error) {
    //       this.loading = false;
    //     } finally {
    //       this.selectedFiles = [];
    //     }
    //   }, 500);
    // },
    uploadFiles() {
      if (this.selectedFiles.length === 0) {
        alert("Pilih beberapa file terlebih dahulu.");
        this.loading = false;
        return;
      }
      this.loading = true;
      this.uploadProgress = 0
      // Bagi array file menjadi beberapa bagian
      let chunks = [];
      for (let i = 0; i < this.selectedFiles.length; i += this.filesPerRequest) {
        chunks.push(this.selectedFiles.slice(i, i + this.filesPerRequest));
      } 

      // Fungsi rekursif untuk mengunggah setiap bagian secara berurutan
      const uploadChunksSequentially = async (chunks, index = 0) => {
        if (index < chunks.length) {
          const chunk = chunks[index];
          for (const file of chunk) {
            await this.uploadToServer(file);
          }
          await uploadChunksSequentially(chunks, index + 1);
        } else {
          this.loading = false;
          this.selectedFiles = [];
        }
      };

      uploadChunksSequentially(chunks);
    },
    uploadToServer(file) {
      // Mengirim file ke server menggunakan Fetch API
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('attachment', file);
        this.uploadImageV2(formData)
          .then((res) => {
            // Simpan URL file yang dikembalikan oleh API ke dalam data array
            this.listData.push(res.product_path); 
            this.uploadProgress++
            resolve(res)
          })
          .catch((error) => {
            this.loading = false;
            console.error("Error:", error);
            reject(error);
          });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.card-upload {
  position: relative;

  .delete-upload {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
  }
}

.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>